import React from "react";
import { Box } from "@mui/material";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

export const fileSize = (bytes: number) =>
  bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;

const KINDS = [
  { test: (m: string) => m === "application/pdf", Icon: PictureAsPdfOutlinedIcon, color: "#C2410C", bg: "#FFF1E8" },
  { test: (m: string) => m.startsWith("image/"), Icon: ImageOutlinedIcon, color: "#0E7490", bg: "#E6F6F9" },
  { test: (m: string) => m.includes("word"), Icon: ArticleOutlinedIcon, color: "#1D4ED8", bg: "#EAF0FF" },
];

/** A tinted square with the file kind's icon: PDF, photo, Word or other. */
export const FileTypeIcon: React.FC<{ file: { mimeType: string }; size?: number }> = ({ file, size = 36 }) => {
  const kind = KINDS.find((k) => k.test(file.mimeType));
  const Icon = kind?.Icon ?? InsertDriveFileOutlinedIcon;
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: size > 40 ? 3 : 2,
        bgcolor: kind?.bg ?? "#F1F5F9",
        color: kind?.color ?? "text.secondary",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon sx={{ fontSize: size * 0.55 }} />
    </Box>
  );
};
